import { createApi } from '@reduxjs/toolkit/query/react';

import { setHealthProfile } from 'store/healthProfile/healthProfileSlice';

import { logDataDogEvent } from 'utils/datadog';
import { baseQueryWithReauth } from 'utils/services';

import {
  GetHealthProfileDataProps,
  GetHealthProfileReqProps,
  GetHealthProfileResProps
} from './healthProfile.types';

export const healthProfileApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getHealthProfile: build.query<GetHealthProfileDataProps, GetHealthProfileReqProps>({
      keepUnusedDataFor: 0,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setHealthProfile(data));
          }
        } catch (e) {
          logDataDogEvent({
            context: { error: e },
            level: 'error',
            message: 'getHealthProfile sync failed'
          });
        }
      },
      query: () => '/health-profile',
      transformResponse: (response: GetHealthProfileResProps) => response.data
    })
  }),
  reducerPath: 'healthProfileApi',
  tagTypes: ['HealthProfile']
});

export const { useGetHealthProfileQuery } = healthProfileApi;
